module.exports = __webpack_public_path__ + "static/media/credit_note_icon.2a96e39d.svg";